"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Loader, CircleCheck } from "lucide-react";
function ParticipationFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-12 text-center space-y-4">
        <CircleCheck className="size-16 text-primary" />
        <h3 className="text-2xl font-default font-bold text-foreground">
          Richiesta Inviata!
        </h3>
        <p className="text-muted-foreground max-w-md">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6 rounded-sm">
          Invia un'altra richiesta
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <FormField control={control} name="nome" rules={{
        required: "Il nome è obbligatorio",
        minLength: {
          value: 2,
          message: "Minimo 2 caratteri"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Nome</FormLabel>
              <FormControl>
                <Input placeholder="Il tuo nome" className="bg-background rounded-sm" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="cognome" rules={{
        required: "Il cognome è obbligatorio",
        minLength: {
          value: 2,
          message: "Minimo 2 caratteri"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Cognome</FormLabel>
              <FormControl>
                <Input placeholder="Il tuo cognome" className="bg-background rounded-sm" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <FormField control={control} name="email" rules={{
        required: "L'email è obbligatoria",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Inserisci un indirizzo email valido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="tua@email.it" className="bg-background rounded-sm" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="telefono" rules={{
        required: "Il numero di telefono è obbligatorio",
        pattern: {
          value: /^[0-9+\-\s()]*$/,
          message: "Inserisci un numero di telefono valido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Telefono</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="Il tuo numero" className="bg-background rounded-sm" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="mb-8">
        <FormField control={control} name="zona" rules={{
        required: "Seleziona la tua zona di riferimento"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Zona</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger className="bg-background rounded-sm">
                    <SelectValue placeholder="Seleziona la tua zona" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent className="rounded-sm">
                  <SelectItem value="albano">Albano</SelectItem>
                  <SelectItem value="pavona">Pavona</SelectItem>
                  <SelectItem value="cecchina">Cecchina</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>} />
      </div>

      {submitError && <div className="p-4 mb-6 bg-destructive/10 border border-destructive/20 rounded-sm">
          <p className="text-destructive text-sm font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto md:min-w-[200px] rounded-sm text-base py-6" size="lg">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Invio in corso...
          </> : "Partecipa Ora"}
      </Button>
    </Form>;
}
export default function ParticipationForm() {
  return;
}